<template>
  <div class="product-gallery-modal">
    <button
      class="product-gallery-modal__close-button icon-button overlay__close"
      :aria-label="$string('accessibility.close')"
      @click.prevent="handleCloseClick"
    >
      <slot name="close">
        <animated-icon
          :transition-on-hover="true"
          transition-type="spin-90"
        >
          <template #iconOne>
            <icon-close />
          </template>

          <template #iconTwo>
            <icon-close />
          </template>
        </animated-icon>
      </slot>
    </button>

    <transition name="fade">
      <product-gallery-zoom
        v-cloak
        :current-index="currentIndex"
        :modal-active="isActive"
        :images="images"
        @update-gallery-index="handleZoomGalleryIndexUpdate"
      />
    </transition>
  </div>
</template>

<script>

/**
 * Vue: Product gallery modal (product-gallery-modal)
 * -----------------------------------------------------------------------------
 * Product Gallery overlay housing 'Zoomed' state.
 * @param {Number} currentIndex - default/current images index for the carousel.
 * @param {Boolean} isActive - Overlay drawer is active.
 * @param {Array, Boolean} [images] - Array of images from a formatted product object.
 */
import { mapActions } from 'vuex'

import AnimatedIcon from '~global/animated-icon/animated-icon'
import ProductGalleryZoom from '~async/product-gallery-zoom/product-gallery-zoom'

import IconClose from '~icons/misc/close.svg'

export default {
  name: 'ProductGalleryModal',

  components: {
    AnimatedIcon,
    IconClose,
    ProductGalleryZoom,
  },

  props: {
    currentIndex: {
      type: Number,
      default: 0,
    },
    images: {
      type: [Boolean, Array],
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update-gallery-index'],

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      closeOverlay: 'overlays/close',
      loadComponent: 'components/load',
    }),

    /**
     * Events for when the 'Close' button is clicked.
     */
    handleCloseClick() {
      this.closeOverlay('productGalleryModal')
    },

    /**
     * The user has modified the active slide in the 'Zoom modal'.
     * - Notify parent component.
     * @param {Number} index - Index within for loop.
     */
    handleZoomGalleryIndexUpdate(index) {
      this.$emit('update-gallery-index', index)
    },
  },
}
</script>

<style lang="scss">
@import './product-gallery-modal';
</style>
